import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, map, throwError } from 'rxjs';
import { Birim } from 'src/app/models/birim.model';
import { Kategori } from 'src/app/models/kategori.model';
import { Kullanici } from 'src/app/models/kullanici.model';
import { KullaniciTalep } from 'src/app/models/kullaniciTalep.model';
import { GirisService } from 'src/app/services/giris.service';
import { KullaniciTalepService } from 'src/app/services/kullanici-talep.service';
import { ProfilService } from 'src/app/services/profil.service';
import { ValidationService } from 'src/app/services/validation.service';
import { YetkiService } from 'src/app/services/yetki.service';
import { data } from 'src/assets/js/components/util';
import Swal from 'sweetalert2';

@Component({
  selector: 'kullanici-talep-islem',
  templateUrl: './kullanici-talep-islem.component.html',
  styleUrls: ['./kullanici-talep-islem.component.css']
})
export class KullaniciTalepIslemComponent implements OnInit {

  constructor(private router: Router, public kullaniciTalepService: KullaniciTalepService, private validationService: ValidationService, private route: ActivatedRoute, private formBuilder: FormBuilder, public yetkiService: YetkiService, private http: HttpClient, private profilService: ProfilService, private girisService: GirisService) { }


  // talepKategoriler: any[] = [
  //   { id: 0, name: "Seçiniz." },
  //   { id: 1, name: "İstek" },
  //   { id: 2, name: "Öneri" },
  //   { id: 3, name: "Hata" },
  // ];

  // todoItem={
  //   description:"test",
  //   action:true
  // }



  kisiAdSoyad: string = "";
  kullanici: Kullanici = new Kullanici();
  detayForm = this.formBuilder.group(new KullaniciTalep());
  dosyaUrl = "";

  yeni = true;
  kullaniciTalep: KullaniciTalep = new KullaniciTalep();
  yukleniyor = false;
  kaydediliyor = false;
  hatalar: any = {};
  durumlar: any[] = [];
  selectedFile: File | null = null;
  file: any;
  islemDurum: number = 0;
  dosyaYukDurum: string = "";
  dosyaKontrol = 0;
  dosyaAd: string = "";
  dyol: string = "";
  talepBirimler: Birim[] = [];
  talepKategoriler: Kategori[] = [];
  secilenBirimId: number = 0;
  aciklamaKapat = false;
  ogrSifreTalep = false;
  ngOnInit(): void {
    this.birimList();
    this.kategoriList();
    this.route.params.subscribe(params => {
      if (params['id'] != 'yeni') {
        this.getById(params['id']);
      }
    });
  }


  birimList() {
    this.kullaniciTalepService.getBirimList().subscribe(res => {
      this.talepBirimler = res.data;
    });
  }

  kategoriList() {
    this.kullaniciTalepService.getKategoriList().subscribe(res => {
      this.talepKategoriler = res.data;
    });
  }



  selectFile(e: any) {
    this.file = e.target.files[0];
    this.dosyaKontrol = 1;
  }

  fileDelete() {
    this.kullaniciTalepService.dosyaSil(this.dosyaUrl).pipe(finalize(() => {
    })).subscribe({
      next: res => {
        this.dosyaUrl = "";
      },
      error: err => {
      }
    });
  }

  upload() {
    this.kaydediliyor = true;
    if (this.dosyaKontrol == 1) {
      this.hatalar = {};
      const formData = new FormData();
      formData.append("file", this.file);

      this.kullaniciTalepService.dosyaYukle(formData).pipe(finalize(() => {
      })).subscribe({
        next: res => {
          this.dosyaUrl = res.data.filePath;
          this.dosyaYukDurum = "";
          this.kaydetGuncelle();
        },
        error: err => {
          this.dosyaYukDurum = err.error?.message;
          this.hatalar = this.validationService.hatalar(err.error.Errors);
          if (err.error.Errors == undefined || err.error.Errors == null || err.error.Errors?.length == 0) {
            if (err.error?.message && err.error?.message != "") { this.yetkiService.error(err.error?.message, 1) };
            if (err.error?.Message && err.error?.Message != "") { this.yetkiService.error(err.error?.Message, 1) };
          }
          this.kaydediliyor = false;
        }
      });
    }
    else {
      this.kaydetGuncelle();
    }

  }

  getById(id: number) {
    this.yukleniyor = true;
    this.kullaniciTalepService.getById(id).subscribe(res => {
      this.kullaniciTalep = res.data;
      this.dyol = res.data?.dosyaUrl;
      this.yeni = false;
      this.detayForm.patchValue(res.data);
      this.yukleniyor = false;
      if (this.dyol) {
        this.kullaniciTalepService.dosyaBilgi(this.dyol).subscribe(dosyaAd => {
          this.dosyaAd = dosyaAd.data.dosyaAd;
        })
      }
    }, err => {
      this.yukleniyor = false;
      this.router.navigateByUrl('/')
    },);
  }
  secBirimkontrol() {
    // seçilen birim bilgi işlemse
    if (this.secilenBirimId == 31) {
      this.aciklamaKapat = true;
    }
    else { this.aciklamaKapat = false; }
  }

  rdkontrol() {
    if (this.ogrSifreTalep) {

      this.aciklamaKapat = true;
      this.kullanici=this.girisService.girisBilgi();
      var tckimliknoint: number = +this.kullanici.tckimlikno;

      this.profilService.getByTCKimlikNo(tckimliknoint).subscribe(res => {
          Swal.fire({
            title: '<b>Bilgiler</b>',
            //text: 'Öğrenci Mail : <b>'+res?.ogrenciEPosta+'</b>',
            html:'<span class=fs-3>Öğrenci E-posta : <b>'+res?.ogrenciEPosta+'</b></span> <br><br> <span class=fs-3>Öğrenci E-posta hesabınıza <a href=https://ogrposta.erbakan.edu.tr target=_blank>giriş yapmak için tıklayınız.</a></span><br><br><span class=fs-3>Office 365 şifrenizi sıfırlamak veya yeni lisans <a href=https://lisans.erbakan.edu.tr/ target=_blank>almak için tıklayınız.</a></span>',
            icon: 'info',
            showCancelButton: false,
            confirmButtonText: 'Tamam',
          
          })
      });

    }
    else { this.aciklamaKapat = false; }
  }


  kaydetGuncelle() {
    this.hatalar = {};
    var form = this.detayForm.value;
    form.dosyaUrl = this.dosyaUrl;

    this.kullaniciTalepService.addUpdate(form).pipe(finalize(() => {
    })).subscribe({
      next: res => {
        if (res?.message && res?.message != "") { this.yetkiService.success(res?.message, 1) };
        this.router.navigateByUrl('/talep-list')
      },
      error: err => {
        this.hatalar = this.validationService.hatalar(err.error.Errors);

        if (err.error.Errors == undefined || err.error.Errors == null || err.error.Errors?.length == 0) {
          if (err.error?.message && err.error?.message != "") { this.yetkiService.error(err.error?.message, 1) };
          if (err.error?.Message && err.error?.Message != "") { this.yetkiService.error(err.error?.Message, 1) };
        }
        this.kaydediliyor = false;
        this.fileDelete();
      }
    });

  }

}
